import React from 'react'
import {Link} from 'react-router-dom'
import CloseOutlined from '@ant-design/icons/CloseOutlined'

import {nameRenderer} from 'utils/user'
import ProductCategories from 'modules/AppHeader/ProductCategories'
import useCartContext from 'components/Cart/useCartContext'

const LogoAndLinks = ({isSearching, user, cart, closeSearchMain, t}) => {
  const {setCartVisible} = useCartContext()

  return (
    <>
      <div id='nav-topBar'>
        <div>
          <Link to='/about-us'>{t('ABOUT US')}</Link>
          <Link to='/about-us'>{t('HOW DOES IT WORK')}</Link>
          <Link to='/about-us'>{t('TRADE PERSON')}</Link>
        </div>
      </div>
      <div id='nav-mainNav'>
        <div>
          <div><ProductCategories/></div>
          <div>
            {isSearching ? (
              <button className='nav-close' onClick={() => closeSearchMain()}>{t('CLOSE')}<CloseOutlined/></button>
            ) : <>
              {user ? (
                <>
                  <Link to='/profile'>{nameRenderer(user)}</Link>
                  <Link to='/logout'>{t('Log out')}</Link>
                </>
              ) : (
                <Link to='/login'>{t('Log in')}</Link>
              )}
              <button onClick={() => setCartVisible(true)}>{t('Cart', {itemCount: Object.keys(cart.items).length})}</button>
            </>}
          </div>
        </div>
      </div>
      <div id='nav-logo'><Link to='/'/></div>
    </>
  )
}

export default LogoAndLinks
